import { render, staticRenderFns } from "./ReportThumbnail.vue?vue&type=template&id=2850967e&"
import script from "./ReportThumbnail.vue?vue&type=script&lang=js&"
export * from "./ReportThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./ReportThumbnail.vue?vue&type=style&index=0&id=2850967e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports